<template>
  <div>
    <div class="custom-checkbox" style="display: flex; align-items: flex-start; gap: 0px;">
      <v-checkbox
        type="checkbox"
        :on-icon="'$checked'"
        :off-icon="'$uncheck'"
        v-model="computedValue"
        hide-details
      ></v-checkbox>
      <span
        v-html="label"
        :style="{
          'font-size': textSize
        }"
      ></span>
    </div>
    <span
      v-if="errorMessages"
      :style="{
        'font-size': '13px',
        color: '#b71c1c'
      }"
    >
      {{ errorMessages }}
    </span>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: 'medium',
      validator: value => ['small', 'medium', 'large', 'xl'].includes(value)
    },
    label: {
      type: String,
      default: ''
    },
    errorMessages: {
      type: [String, Array],
      default: null
    }
  },
  computed: {
    computedValue: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
        this.$emit('change', val)
      },
    },
    textSize() {
      const sizes = {
        small: '12px',
        medium: '15px',
        large: '16px'
      }
      return sizes[this.size] || sizes.medium
    }
  }
}
</script>

<style scoped>
.custom-checkbox >>> .v-input--selection-controls {
  margin-top: 0 !important;
  padding-top: 0 !important;
}

.custom-checkbox >>> .v-input--selection-controls__input {
  margin-top: 0 !important;
}
</style>
